"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelUpWebhookResponseToJSON = exports.LevelUpWebhookResponseFromJSONTyped = exports.LevelUpWebhookResponseFromJSON = void 0;
function LevelUpWebhookResponseFromJSON(json) {
    return LevelUpWebhookResponseFromJSONTyped(json, false);
}
exports.LevelUpWebhookResponseFromJSON = LevelUpWebhookResponseFromJSON;
function LevelUpWebhookResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userLevel': json['userLevel'],
        'usdReward': json['usdReward'],
    };
}
exports.LevelUpWebhookResponseFromJSONTyped = LevelUpWebhookResponseFromJSONTyped;
function LevelUpWebhookResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userLevel': value.userLevel,
        'usdReward': value.usdReward,
    };
}
exports.LevelUpWebhookResponseToJSON = LevelUpWebhookResponseToJSON;
